'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');

var template = require('modules/collection/templates/components/filter/enum.hbs');

var EnumView = FilterComponentView.extend({
    template: template,

    ui: {
        'multipleOptions': '.component-filter-buttons input[type="checkbox"]',
    },

    events: {
        'change @ui.multipleOptions': 'change',
    },

    viewData: {
        enumValues: function() {
            var enumValues = this.getOption('options').enumValues;

            if (!_.isArray(enumValues)) {
                console.warn('Missing enumValues for filter', this.getOption('name'));

                enumValues = [];
            }

            return enumValues;
        },
    },

    getFilterValueDisplayName: function(value) {
        var enumValue = _.findWhere(this.getOption('options').enumValues, {'name': value});

        return enumValue ? enumValue.label : '';
    },

    getFilters: function() {
        var filters = [];

        var multipleOptions = this.ui.multipleOptions.filter(':checked');

        multipleOptions.each(function(index, option){
            option = $(option);
            filters.push({value: option.val(), displayName: option.next('label').text().trim()});
        });

        return filters;
    },

    setFilters: function(filters) {
        filters = filters.split(',');

        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', _.contains(filters, $(option).val()));
        });
    },

    resetFilters: function() {
        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', false);
        });

        this.change();
    },
});

module.exports = EnumView;